module.exports = __webpack_public_path__ + "assets/font/SourceHanSansCN-Normal-4bf258e4.otf";